import { Suspense } from 'react';
import {
  Redirect,
  Route as ReactDOMRoute,
  RouteProps as ReactDOMRouteProps,

} from 'react-router-dom';

import { useAuth } from '../contexts/auth';
import { URI } from '../contracts/enums';

interface RouteProps extends ReactDOMRouteProps {
  isPrivate?: boolean;
  component: any;
  children?: any
}

const Route: React.FC<RouteProps> = ({
  isPrivate = false,
  component: Component,
  ...rest
}) => {
  const { user } = useAuth();

  return (
    <ReactDOMRoute
      {...rest}
      render={({ location }) => {
        return isPrivate === !!user ? (
          <Suspense fallback={''}>
            <Component />
          </Suspense>
        ) : (
          <Redirect
            to={{
              pathname: isPrivate ? URI.base : URI.dashboard,
              state: { from: location },
            }}
          />
        );
      }}
    />
  );
};

export default Route;